import React, { PropsWithChildren } from 'react'
import classNames from 'classnames/bind'

import Style from './ResidentAuthLayout.module.scss'

const cx = classNames.bind(Style)

const ResidentAuthLayout = ({ children }: PropsWithChildren<unknown>) => {
  return <div className={cx('article')}>{children}</div>
}

export default ResidentAuthLayout
